export enum SaveEnvironmentOption {
	newEnvironment = 0,
	createRevision = 1,
	objectEnvironment = 2,
	imageImport = 3,
}
